import React from 'react'
import { CloseIcon } from '../Icons'
import { Wrapper, CloseButton, Overlay } from './Drawer.styles'

export const Drawer = ({ open, onClose, children }) => {
  if (!open) {
    return null
  }

  return (
    <>
      <Wrapper>
        <CloseButton onClick={onClose} aria-label="Fechar">
          <CloseIcon aria-hidden={true} />
        </CloseButton>
        {children}
      </Wrapper>
      <Overlay onClick={onClose} />
    </>
  )
}
